import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./TravellerDetailPage.css";



const TravellerDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentType, setPaymentType] = useState("full");
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const data =
    location.state || JSON.parse(localStorage.getItem("bookingData"));

  // ✅ ALWAYS hooks at top
  const [pickupLocation, setPickupLocation] = useState(data?.pickup || "");
  const [roofCarrier, setRoofCarrier] = useState(false);
const [showPolicy, setShowPolicy] = useState(false);
const [formData, setFormData] = useState({
  fullName: "",
  companyName: "",
  gstAddress: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  guestPhone: "", 
  traveler: "I am the main traveler",
  businessTrip: "No",
  requests: "",
});

  const [errors, setErrors] = useState({});
const basicFeatures = [
  "Spare Tyre",
  "2 Front Airbags",
  "Child Seat",
  "ABS (Anti-lock)",
];

const extraFeatures = [
  "Reverse Camera",
  "Toolkit",
  "Bluetooth",
  "USB Charging",
];
  // ✅ Safety check AFTER hooks
  if (!data || !data.carData) {
    return <h2 style={{ textAlign: "center" }}>No Data Found</h2>;
  }

  const { carData, pickup,totalPrice = 0 } = data;

 const finalPrice = roofCarrier ? totalPrice + 100 : totalPrice;

 const payableAmount =
   paymentType === "half" ? Math.round(finalPrice / 2) : finalPrice;

  // ================= FORM HANDLER =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone" && !/^[0-9]*$/.test(value)) return;

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = "First name required";

    if (!formData.lastName.trim()) newErrors.lastName = "Last name required";

    if (!formData.email) newErrors.email = "Email required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email";

    if (!formData.phone) newErrors.phone = "Phone required";
    else if (formData.phone.length !== 10)
      newErrors.phone = "Must be 10 digits";

 if (
   formData.traveler === "Booking for someone else" &&
   (!formData.guestPhone || formData.guestPhone.length !== 10)
 ) {
   newErrors.guestPhone = "Guest phone must be 10 digits";
 }

    if (formData.businessTrip === "Yes") {
      if (!formData.companyName.trim())
        newErrors.companyName = "Company required";
      if (!formData.gstAddress.trim())
        newErrors.gstAddress = "Address required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const handleSubmit = () => {
 const tax = Math.round(totalPrice * 0.18);
 const discount = 200;

 const totalFare = finalPrice + tax - discount;

 const payNow = paymentType === "half" ? Math.round(totalFare / 2) : totalFare;
  if (validate()) {
    navigate("/payment-page", {
      state: {
        ...data,
        email: formData.email,
        amount: payNow, 
        totalFare: totalFare, 
        paymentType: paymentType,
      },
    });
  }
};

 return (
   <div className="booking-page">
     {/* 🔹 TOP IMAGE GALLERY */}
     <div className="top-gallery">
       <img
         src={carData.img || "https://source.unsplash.com/800x400/?car"}
         className="main-img"
         alt="car"
       />
       <div className="side-images">
         <img
           src={
             carData.image ||
             carData.img ||
             "https://source.unsplash.com/800x400/?car"
           }
           className="main-img"
           alt="car"
         />
         <img
           src={
             carData.image ||
             carData.img ||
             "https://source.unsplash.com/800x400/?car"
           }
           className="main-img"
           alt="car"
         />
         <img
           src={
             carData.image ||
             carData.img ||
             "https://source.unsplash.com/800x400/?car"
           }
           className="main-img"
           alt="car"
         />
         <img
           src={
             carData.image ||
             carData.img ||
             "https://source.unsplash.com/800x400/?car"
           }
           className="main-img"
           alt="car"
         />
       </div>
     </div>

     {/* 🔹 HEADER */}
     <div className="header">
       <div>
         <h1>{carData.name}</h1>
         <p>
           {carData.type} • {carData.fuel} • {carData.capacity}
         </p>
       </div>
       <div className="location-box">
         <p>LOCATION</p>
         <h3>{pickup}</h3>
         <p className="edit-link" onClick={() => navigate("/")}>
           Edit Details
         </p>
       </div>
     </div>

     {/* 🔹 MAIN LAYOUT */}
     <div className="layout">
       {/* LEFT SIDE */}
       <div className="left">
         {/* KEEP YOUR EXISTING TRIP BOX */}
         <div className="card">
           <label> Enter your detailed pickup location</label>
           <input type="text" placeholder="Enter Exact Pickup Location" />
         </div>

         {/* CAR INFO */}

         {/* FEATURES */}
         <div className="car-booking-card-features">
           <div className="features-section">
             <h2>Car Features</h2>

            <div className={`features-grid ${showAllFeatures ? "three-col" : "two-col"}`}>
  {basicFeatures.map((item, index) => (
    <div key={index} className="feature">✅ {item}</div>
  ))}

  {showAllFeatures &&
    extraFeatures.map((item, index) => (
      <div key={index} className="feature">✅ {item}</div>
    ))}
</div>

             <p
               className="view-more"
               onClick={() => setShowAllFeatures(!showAllFeatures)}
             >
               {showAllFeatures ? "Show Less" : "View More Features"}
             </p>
           </div>
         </div>

         {/* POLICY */}
         <div className="policy-section">
           <h2>Rental Policy</h2>

           <div className="policy-row">
             <span className="inclusion">● Inclusion: Fuel (100km)</span>
             <span className="exclusion">● Exclusion: Toll/Parking</span>
           </div>

           <button
             className="rental-policy-btn"
             onClick={() => setShowPolicy(true)}
           >
             Read Full Policy
           </button>
         </div>
       </div>

       {/* RIGHT SIDE */}
       <div className="right">
         <div className="form-card">
           <h3 className="guest-heading">Traveller Information</h3>

           <div className="guest-row">
             <div>
               <input
                 name="firstName"
                 placeholder="First Name"
                 value={formData.firstName}
                 onChange={handleChange}
                 className="traveller-input"
               />
               {errors.firstName && <p className="error">{errors.firstName}</p>}
             </div>

             <div>
               <input
                 name="lastName"
                 placeholder="Last Name"
                 value={formData.lastName}
                 onChange={handleChange}
                 className="traveller-input"
               />
               {errors.lastName && <p className="error">{errors.lastName}</p>}
             </div>
           </div>

           <input
             name="email"
             placeholder="Email"
             value={formData.email}
             onChange={handleChange}
             className="traveller-input"
           />
           {errors.email && <p className="error">{errors.email}</p>}

           <div className="guest-row">
             <select className="traveller-select">
               <option>India (+91)</option>
             </select>
             <input
               name="phone"
               placeholder="Phone"
               value={formData.phone}
               onChange={handleChange}
               className="traveller-input"
             />
             {errors.phone && <p className="error">{errors.phone}</p>}
           </div>

           <label className="traveller-label">Who is traveling?</label>
           <select
             name="traveler"
             value={formData.traveler}
             onChange={handleChange}
             className="traveller-select"
           >
             <option>I am the main traveler</option>
             <option>Booking for someone else</option>
           </select>

           {formData.traveler === "Booking for someone else" && (
             <>
               <input
                 name="fullName"
                 placeholder="Guest Name"
                 value={formData.fullName}
                 onChange={handleChange}
                 className="traveller-input"
               />
               <input
                 name="guestPhone"
                 placeholder="Guest Phone"
                 value={formData.guestPhone || ""}
                 onChange={handleChange}
                 className="traveller-input"
               />
               {errors.guestPhone && (
                 <p className="error">{errors.guestPhone}</p>
               )}
             </>
           )}

           <div className="price-box">
             <h3>Fare Summary</h3>

             <div className="price-row">
               <span>Base Fare</span>
               <span>₹{totalPrice}</span>
             </div>

             {/* DISCOUNT (example static, you can change later) */}
             <div className="price-row discount">
               <span>Discount</span>
               <span>-₹200</span>
             </div>

             {/* TAX */}
             <div className="price-row">
               <span>Taxes & Fees (18%)</span>
               <span>₹{Math.round(totalPrice * 0.18)}</span>
             </div>

             {/* ROOF CARRIER INSIDE BOX */}
             <div className="price-row checkbox-row">
               <label className="traveller-label">
                 <input
                   type="checkbox"
                   checked={roofCarrier}
                   onChange={() => setRoofCarrier(!roofCarrier)}
                   className="traveller-input"
                 />
                 Add Roof Carrier (+₹100)
               </label>
               <span>{roofCarrier ? "₹100" : "₹0"}</span>
             </div>

             <hr />

             {/* TOTAL */}
             <div className="price-total">
               <span>Total Fare</span>
               <span>₹{finalPrice + Math.round(totalPrice * 0.18) - 200}</span>
             </div>

             {/* PAYABLE */}
           </div>

           <div className="payment-type-box">
             <label>
               <input
                 type="radio"
                 name="payment"
                 value="full"
                 checked={paymentType === "full"}
                 onChange={(e) => setPaymentType(e.target.value)}
               />
               Full Payment
             </label>
             <label>
               <input
                 type="radio"
                 name="payment"
                 value="half"
                 checked={paymentType === "half"}
                 onChange={(e) => setPaymentType(e.target.value)}
               />
               Half Payment (remaining pay to the driver)
             </label>
           </div>
           <div className="price-pay">
             <span>Pay Now</span>
             <span>
               ₹
               {paymentType === "half"
                 ? Math.round(
                     (finalPrice + Math.round(totalPrice * 0.18) - 200) / 2,
                   )
                 : finalPrice + Math.round(totalPrice * 0.18) - 200}
             </span>
           </div>

           <button type="button" className="payment-btn" onClick={handleSubmit}>
             CONTINUE TO PAYMENT
           </button>
         </div>
       </div>
     </div>

     {showPolicy && (
       <div className="modal-overlay">
         <div className="modal">
           <span className="close" onClick={() => setShowPolicy(false)}>
             ✖
           </span>
           <h2>Booking Policy</h2>
           <p>✔ Fuel included for 100km</p>
           <p>✔ 24/7 Roadside Assistance</p>
           <p>✖ Toll & Parking extra</p>
         </div>
       </div>
     )}
   </div>
 );
};

export default TravellerDetailPage;
